export default __webpack_public_path__ + "static/media/group-8391.adb70a90.png";